import { Component, ViewEncapsulation, input, inject } from '@angular/core';
import { NgControl, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgTemplateOutlet } from '@angular/common';

import { ApInputConstraintService } from '@ap/input/constraint';
import { ApContentService } from '@ap/content';
import { ApIconComponent } from '@ap/icon';
import { ApFormErrorsComponent } from '@ap/form/errors';
import { ApSuggestionComponent } from '@ap/input/suggestion';

import { AbstractInputComponent } from './abstract-input.component';
import { InputType } from './input.type';
import { ApAutocompleteFilterService } from './autocomplete/autocomplete-filter/autocomplete-filter.service';
import { InputmodeType } from './inputmode.type';
import { ApAutocompleteModule } from './autocomplete';

@Component({
    selector: 'ap-input',
    templateUrl: 'input.component.html',
    styleUrls: ['input.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    imports: [
        ReactiveFormsModule,
        FormsModule,
        ApIconComponent,
        ApSuggestionComponent,
        ApFormErrorsComponent,
        ApAutocompleteModule,
        NgTemplateOutlet
    ],
    providers: [ApInputConstraintService]
})
export class ApInputComponent extends AbstractInputComponent {
    protected control = inject(NgControl, { self: true, optional: true });
    protected readonly inputConstraintService = inject(ApInputConstraintService);
    protected readonly contentService = inject(ApContentService);
    protected readonly filterService = inject(ApAutocompleteFilterService);

    /**
     * Removes inputs that matches given regex
     */
    public readonly stripPattern = input<RegExp>(/''/);

    /**
     * Maxlength of input
     */
    public readonly maxlength = input<number>(null);

    /**
     * Prefix before input
     */
    public readonly prefix = input<string>(null);

    /**
     * Type of input (Standard HTML types)
     */
    public readonly type = input<InputType>('text');

    /**
     * Trim value on blur
     */
    public readonly trim = input(false);

    /**
     * Inputmode (Standard HTML inputmode types)
     */
    public readonly inputmode = input<InputmodeType>(null);

    constructor() {
        super();
    }

    /**
     * Placeholder function that inputs can overwrite
     */
    protected override formatValue(value: string): string {
        return (this.trim() && value?.trim()) || value;
    }
}
